import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[cardTitle]',
  standalone: true
})
export class CardTitleDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
